import { EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { QueryParams } from '../grid/grid-params';

export abstract class Filter {

  public onChange: EventEmitter<any> = new EventEmitter<any>();
  protected queryParams: QueryParams = null;
  private filterGridParamName: string = 'filters';

  constructor (
    protected filterName: string,
    private defaultValue: any = null
  ) { }

  abstract getFormElement(): FormGroup | FormControl;
  abstract updateValue();
  abstract clearValue();

  public setQueryParams(queryParams: QueryParams) {
    this.queryParams = queryParams;
  }

  public getFilterName(): string {
    return this.filterName;
  }

  protected getFilterCriteria(field: string): string {
    return this.queryParams.getParam(this.getFieldParamName(field));
  }

  protected unsetFilterCriteria(field: string) {
    this.queryParams.setParam('page', 1);
    this.queryParams.unsetParam(this.getFieldParamName(field));
  }

  protected setFilterCriteria(field: string, value: string) {
    let param: string = this.getFieldParamName(field);
    this.queryParams.setParam('page', 1);

    if ('' === value) {
      this.queryParams.unsetParam(param);

      return;
    }

    this.queryParams.setParam(param, value);
  }

  protected getValue() {
    let paramKey: string = this.getFieldParamName(this.filterName);

    if (
      null !== this.queryParams &&
      this.queryParams.params.hasOwnProperty(paramKey)
    ) {
      return this.queryParams.params[paramKey];
    }

    return this.defaultValue;
  }

  private getFieldParamName(field: string) {
    return this.filterGridParamName + '[' + field + ']';
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/filter-form/filter.class.ts